// extracted by mini-css-extract-plugin
module.exports = {"card-component":"Card_card-component__3Pm5T","card-title":"Card_card-title__c6MDH"};